import { isEmpty } from 'ramda'
import { useChangeSearch, useFilter, useSearch } from '@btime/react-contexts'
import { useTranslation } from 'react-i18next'
import React, { Fragment, useState } from 'react'

import DropdownLink from '../../../components/navigation/DropdownLink'
import FiltersBar from './filters/FiltersBar'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import IconButton from '../../../components/actions/IconButton'
import SearchInput from '../../../components/form/SearchInput'
import Separator from '../../../components/helpers/Separator'

const ControlBar = () => {
  const { t } = useTranslation()

  const hasFilter = !isEmpty(useFilter())
  const [isFiltering, setFiltering] = useState(hasFilter)
  const hideFilter = () => setFiltering(false)
  const toggleFilter = () => setFiltering(!hasFilter ? !isFiltering : true)

  const changeSearch = useChangeSearch()
  const search = useSearch()

  const options = [
    { label: t('views.list'), value: 'list', iconLeft: 'BsListTask' },
    { label: 'Visão de cards (em breve)', disabled: true, value: 'cards', iconLeft: 'BsCardText' }
  ]

  return (
    <Fragment>
      <Separator weight={4} />
      <FlexGrid justify="space-between" gutter={0.4}>
        <FlexCol>
          <DropdownLink
            actionContent={<IconButton iconLeft="BsListTask" label={t('views.list')} transparent noWrap />}
            options={options}
          />
        </FlexCol>

        <FlexCol>
          <IconButton iconLeft="BsFunnel" label={t('filter')} transparent noWrap onClick={toggleFilter} />
        </FlexCol>

        <FlexCol flex={3} />
        <FlexCol flex={1}>
          <SearchInput value={search} onStopTyping={changeSearch} />
        </FlexCol>
      </FlexGrid>
      <Separator weight={4} />

      <FiltersBar open={isFiltering} onClose={hideFilter} />
    </Fragment>
  )
}

export default ControlBar
